import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Applicant } from '@shared/models/data-model';
import { I18nService } from '@shared/services/i18n.service';
import { IntercomIntegrationService } from '@shared/services/intercomIntegration.service';
import { RegistrationService } from '@shared/services/registration.service';
import { APP_CONFIG, AppConfig } from '@src/app/app-config.module';

@Component({
    selector: 'identity-verified',
    templateUrl: './identity-verified.component.html',
    styleUrl: './identity-verified.component.scss'
})
export class IdentityVerifiedComponent implements OnInit {

    loading = true;
    applicant: Applicant = null;
    postRegistrationInfoUrl: string = null;

    constructor(
        @Inject(APP_CONFIG) private readonly config: AppConfig,
        private readonly registrationService: RegistrationService,
        private readonly intercomIntegrationService: IntercomIntegrationService,
        private readonly i18nService: I18nService,
        private readonly translateService: TranslateService
    ) { }

    ngOnInit() {
        this.translateService.onLangChange.subscribe(e => {
            this.handleLanguageChange(e.lang);
        });
        this.handleLanguageChange(this.translateService.currentLang);

        this.intercomIntegrationService.init();
        this.intercomIntegrationService.onNavigationEnd();
        this.i18nService.turnOnLanguageSelection();

        if (this.registrationService.hasRegistrationContext()) {
            Promise.all([
                this.registrationService.getApplicant(),
                this.registrationService.getComplianceData()
            ]).then(([applicant, complianceData]) => {
                if (complianceData.idvData.some(idvData => idvData.contactId === applicant.contactId)) {
                    this.applicant = applicant;
                }
                this.loading = false;
            });
        } else {
            this.loading = false;
        }

    }

    handleLanguageChange(lang: string) {
        this.postRegistrationInfoUrl = this.config.postRegistrationInfoURLs[lang] || this.config.postRegistrationInfoURLs.fallback;
    }

    clickOnCTA() {
        window.location.assign(this.postRegistrationInfoUrl);
    }
}
